export const BUILD_VERSION = '1790871420';
